import ClearittyLogo from "@/assets/clearitty-logo-alt.svg";
import ClearittyText from "@/assets/icons/clearitty-text.svg";
export default function AppLoading() {
    return (
        <div className="fixed inset-0 flex flex-col gap-8 items-center justify-center bg-natural-100 z-50">
            <div className="flex flex-col items-center justify-center gap-4">
                <ClearittyLogo />
                <ClearittyText className="text-main" />
            </div>
            <div className="w-full max-w-xs bg-gray-300 rounded h-2 overflow-hidden">
                <div className="h-full bg-main animate-loading-bar"></div>
            </div>
        </div>
    )
}